module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Pieces to download")]), _vm._v(" "), _vm._l((_vm.questionsWithFile), function(q) {
    return _c('div', _vm._l((q.files(_vm.values)), function(f) {
      return _c('div', {
        staticClass: "light-frame"
      }, [_c('div', {
        staticStyle: {
          "display": "flex",
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, [_c('div', {
        staticClass: "md-body-2",
        domProps: {
          "innerHTML": _vm._s(f.label.en)
        }
      }), _vm._v(" "), _c('div', {
        on: {
          "click": function($event) {
            return _vm.onClickUpload($event)
          }
        }
      }, [_c('input', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "file",
          "accept": "application/pdf,image/*",
          "multiple": ""
        },
        on: {
          "click": function($event) {
            return _vm.fileInputClick($event, f.id)
          },
          "change": function($event) {
            return _vm.fileInputChange($event, f.id)
          }
        }
      }), _vm._v(" "), _c('md-button', {
        staticClass: "md-icon-button md-raised md-primary md-mini",
        staticStyle: {
          "margin": "16px 0px 16px 16px"
        }
      }, [_c('md-icon', [_vm._v("file_upload")])], 1)], 1)]), _vm._v(" "), (_vm.values._files && _vm.values._files[f.id] && _vm.values._files[f.id]) ? _c('div', _vm._l((_vm.values._files[f.id]), function(file) {
        return _c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_c('md-button', {
          staticClass: "md-icon-button",
          on: {
            "click": function($event) {
              return _vm.removeFile(f.id, file.hashname)
            }
          }
        }, [_c('md-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('md-button', {
          staticClass: "md-accent",
          on: {
            "click": function($event) {
              return _vm.onClickShowFile(file.hashname)
            }
          }
        }, [_vm._v(_vm._s(file.filename))])], 1)
      }), 0) : _vm._e()])
    }), 0)
  }), _vm._v(" "), _vm._l((_vm.uploadingFiles), function(percent, name) {
    return _c('div', [_vm._v("\n    Download" + _vm._s(name) + " : " + _vm._s(percent) + "%\n  ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickContinue()
      }
    }
  }, [_vm._v("Continue")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e25a2bd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Summary.vue
// module id = 740
// module chunks = 3